import React from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '../../../../utils/styles';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbLink,
  BreadcrumbPage,
} from '../../../../components/Common/UI/Breadcrumb';

interface BreadcrumbItem {
  path: string;
  label: React.ReactNode;
  disableBg?: boolean;
}

interface PageSubHeaderProps {
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  breadcrumbs: BreadcrumbItem[];
}

function PageSubHeader({ leftContent, rightContent, breadcrumbs }: PageSubHeaderProps) {
  const { pathname } = useLocation();

  return (
    // TODO when change header from old one to new one - change 'top-[number]' here too to same number.
    // top-14 - if new. top-32 - if old
    <div
      className={cn([
        'sub-header-container sticky top-36 z-50 w-full h-14 px-4',
        'bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        'flex items-center justify-between',
      ])}
    >
      <div className="min-w-32 text-primary text-xl font-bold">{leftContent}</div>

      <Breadcrumb>
        <BreadcrumbList>
          {breadcrumbs.map(({ path, label, disableBg }) => (
            <React.Fragment key={crypto.randomUUID()}>
              <BreadcrumbItem>
                {pathname === path && !disableBg ? (
                  <BreadcrumbPage>{label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink to={path}>{label}</BreadcrumbLink>
                )}
              </BreadcrumbItem>
              <BreadcrumbSeparator className="last:hidden" />
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>

      <div className="min-w-32">{rightContent}</div>
    </div>
  );
}

PageSubHeader.defaultProps = {
  leftContent: undefined,
  rightContent: undefined,
};

export default PageSubHeader;
